let menu = [
    {
        entry: 'Venta',
        shortcut: 'F1',
        route: '/',
    },
    {
        entry: 'Cliente',
        shortcut: 'F4',
        route: 'cliente',
    },
    {
        entry: 'Promos',
        shortcut: 'F5',
        route: 'promos',
    },
    {
        entry: 'Dcto. Cliente',
        shortcut: 'F6',
        route: 'descuentos',
    },
    {
        entry: 'Tickets',
        shortcut: 'F11',
        route: 'reimprimir'
    }
    // {
    //     entry: 'Despacho',
    //     shortcut: 'F7',
    //     route: 'despacho',
    // },
]

menu = menu.map(item => {
    item.disabled = false
    return item
})

menu[3].disabled = true

export default menu
